export default __webpack_public_path__ + "static/media/46k.8817a49f.md";